import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div>
        Built with a passion for what I do. 
      </div>
      <a href="/Himanshu_Raj_Resume.pdf" download="Himanshu_Raj_Resume.pdf">
        <button>Download Resume</button>
      </a>
    </footer>
  );
};

export default Footer;